import  { useEffect } from 'react';

import { useBoosters } from '@/features/boosters/model/useBoosters';
import { useIntroduceBoostersModalStore } from '@/features/boosters/model/useIntroduceBoostersModalStore';

import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

const LS_KEY = 'hasShownBoostersPromo';

export const useBoostersPromo = () => {
  const { canPurchaseBoosters } = useBoosters()
  const openIntroduceBoostersModal = useIntroduceBoostersModalStore((state) => state.open);

  useEffect(() => {
    if (!canPurchaseBoosters) return;

    const hasShown = localStorage.getItem(LS_KEY);
    if (hasShown) return;

    localStorage.setItem(LS_KEY, 'true');
    MixpanelEvents.generalModalBoostersBannerShown();
    openIntroduceBoostersModal();
  }, [openIntroduceBoostersModal, canPurchaseBoosters]);
};
